import { IApplicationState } from '../../types/redux';

export function getFlatTourBookingSchedule(state: IApplicationState) {
  return state.flatTourBooking;
}
